import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from './Navbar.js';
import Mythics from './Mythics.js';
import MythicDetail from "./MythicDetail.js";
import Stats from './Stats.js';
import Leaderboard from './Leaderboard.js';
import HolderProfile from './HolderProfile.js';
import Footer from './Foot.js';
import PrivacyPolicy from './PrivacyPolicy.js';
import NotFound from './404.js';
import ErrorBoundary from './ErrorBoundary.js';
import { WalletProvider } from './WalletContext.js';
import AdminLogin from './Admin/AdminLogin.js';
import AdminDashboard from './Admin/AdminDashboard.js';
import AdminRoute from './Admin/AdminRoute.js';
import { checkAndInvalidateCaches } from './db/cacheManager.js';
import { db } from './db/firebase.js';
import './styles/App.css';
import './styles/Admin.css';

// Extracted so we can use useEffect for the version-based cache check.
function PublicSite() {
    const [showTop, setShowTop] = useState(false);

    useEffect(() => {
        checkAndInvalidateCaches(db);
    }, []);

    useEffect(() => {
        const onScroll = () => setShowTop(window.scrollY > 300);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <WalletProvider>
            <div className="App">
                <Navbar />
                <div className="container">
                    <div className="content">
                        <ErrorBoundary>
                            <Routes>
                                <Route path="/stats" element={<Stats />} />
                                <Route path="/mythics" element={<Mythics />} />
                                <Route path="/mythics/:rank" element={<MythicDetail />} />
                                <Route path="/leaderboard" element={<Leaderboard />} />
                                <Route path="/holders/:walletAddress" element={<HolderProfile />} />
                                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                                <Route path="/404" element={<NotFound />} />
                                <Route path="/" element={<Navigate to="/stats" />} />
                                <Route path="*" element={<Navigate to="/404" />} />
                            </Routes>
                        </ErrorBoundary>
                    </div>
                </div>
                <Footer />
                {showTop && (
                    <button
                        className="back-to-top"
                        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                        aria-label="Back to top"
                    >
                        ↑
                    </button>
                )}
            </div>
        </WalletProvider>
    );
}

function App() {
    return (
        <Router>
            <Routes>
                {/* Admin routes — full-page layout, no Navbar/Footer */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route
                    path="/admin/*"
                    element={
                        <AdminRoute>
                            <AdminDashboard />
                        </AdminRoute>
                    }
                />

                {/* Public site */}
                <Route path="*" element={<PublicSite />} />
            </Routes>
        </Router>
    );
}

export default App;
